import { Auth, Google, Firestore, Storage } from "../../config/firebase";

class AppLogic {
  saveStartUp(data) {
    return Firestore.collection("Feedbacks")
      .add(data)
      .then(res => res)
      .catch(error => {
        throw error;
      });
  }

  saveImage(file) {
    return Storage.ref()
      .child(file.name)
      .put(file)
      .then(res =>
        Storage.ref()
          .child(file.name)
          .getDownloadURL()
          .then(function(url) {
            return url;
          })
      )
      .catch(error => {
        throw error;
      });
  }
}

export default new AppLogic();
